<template>
    <div tabindex="0"  ref="mainContainer" style="outline:none;" :style="styleObject" @blur="closeOptions()">
        <div class="display-value paddingRound mediumRoundAngles" :class="[options.length > 1 ? 'clickable':'']" ref="displayValue" @click="toggleOptions()" :style="'border-color:#555'">
          <span class="value-text" ref="valueText" v-if="options[selectedItem].num == -1">Préparation</span>
          <span class="value-text" ref="valueText" v-else>{{options[selectedItem].english_title}}</span>
            <span class="arrow-down" v-if="options.length > 1"><i class="fas fa-chevron-down"></i></span>
        </div>
        <ul class="select-container paddingRound mediumRoundAngles" ref="selectContainer" :style="'border-color:#555'"
            v-if="options.length > 1"
        >
            <li class="select-option" v-for="(option, key) in options" @click="selected(option, key)">
              <template v-if="option.num == -1">
                Préparation
              </template>
              <template v-else>
                {{option.english_title}}
              </template>
            </li>
        </ul>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "customSelect",
        props: ['options', 'selectedItem', 'name', 'color'],

      computed: {
        ...mapGetters('global', [
          'isMobile',
        ]),
      },

        data(){
            return {
                isOpen: false
            }
        },
        methods:{
            toggleOptions: function() {
              this.isOpen = !this.isOpen;
              if (this.isOpen) {
                this.$refs.selectContainer.style.visibility = 'visible';
                this.$refs.mainContainer.focus();
              } else {
                this.$refs.selectContainer.style.visibility = 'hidden';
              }
            },
            closeOptions: function() {
              this.isOpen = false;
              this.$refs.selectContainer.style.visibility = 'hidden';
            },
            selected: function(val, key) {
                this.$emit('selected', key);
                this.toggleOptions();
            }
        }
    }
</script>

<style scoped>
    .display-value {
        height: fit-content;
        min-width: 10vw;
        display: flex;
        flex-wrap: wrap;
        background: var(--darkColor);
        color: var(--lightColor);
        justify-content: space-between;

    }
    .display-value:hover {
        /*color: #f91e48;*/
    }
    .value-text {
        display: flex;
        padding-left: 0.75vw;
        align-items: center;
        font-weight: bold;
    }
    .arrow-down{
        display: flex;
        padding-right: 0.75vw;
        padding-left: 0.75vw;
        align-items: center;
    }
    .arrow {
        left: 2.5vw;
        top: 0.85vw;
        position: absolute;
    }
    .arrow.arrow-up {
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid black;
    }
    .arrow.arrow-down {
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 6px solid black;
    }
    .select-container {
        min-width: 10vw;
        /*max-height: 12vw;
        overflow: hidden;
        overflow: auto;*/
        position: absolute;
        visibility: hidden;
        margin: 0;
        height: fit-content;
        list-style-type: none;
        display: block;
        background: var(--darkColor);
    }
    .select-container:focus {
        outline:none;
    }
    .select-option {
        height: fit-content;
        display: flex;
        padding-left: 0.75vw;
        padding-right: 0.5vw;
        align-items: center;
        font-size: 110%;
        color: #eeeeee;
    }
    .select-option:hover {
        background: var(--plainColor);
        border-radius: 0.6vw;
        cursor: pointer;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        -webkit-border-radius: 6px;
        border-radius: 6px;
        background: var(--color);
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
    }

    @media screen and (max-device-width: 767px) {
      .display-value {
        min-width: 30vw;
      }
      .select-container {
        min-width: 30vw;
      }
    }

</style>